<div class="mon-accessibility-distribution-container clearfix">
    <div class="check-fixed" [ngStyle]="{width: calcWidth(fixed)}"></div>
    <div class="check-a" [ngStyle]="{width: calcWidth(checkA)}" *ngIf="checkA > 0">A</div>
    <div class="check-aa" [ngStyle]="{width: calcWidth(checkAa)}" *ngIf="checkAa > 0">AA</div>
    <div class="check-aaa" [ngStyle]="{width: calcWidth(checkAaa)}" *ngIf="checkAaa > 0">AAA</div>
</div>
